import React from 'react';

const Step3 = ({
    formData,
    onChange,
    onTradeRefChange,
    onBankRefChange,
    onCreditAmountChange,
    onFileChange,
    onRemoveFile,
    files,
    onBack,
    isSubmit
}) => {
    const finFile = files.financial_statements_file;

    // Sub-Box 1: Trade References (3 references)
    const renderTradeReferences = () => (
        <div className="ref-subbox">
            <div className="ref-subbox-header">
                <span className="ref-subbox-title">Trade References</span>
                <span className="ref-subbox-disclaimer">Company must provide 3 trade references with e-mail addresses &amp; fax numbers.</span>
            </div>
            <div className="table-responsive">
                <table className="ref-table">
                    <thead>
                        <tr>
                            <th className="col-num">#</th>
                            <th style={{ width: '30%' }}>Business Name</th>
                            <th style={{ width: '25%' }}>E-mail Address</th>
                            <th style={{ width: '20%' }}>Fax Number</th>
                            <th style={{ width: '25%' }}>Contact Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(formData.trade_references || []).map((ref, idx) => (
                            <tr key={idx}>
                                <td className="row-num">{idx + 1}.</td>
                                <td>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name={`trade_business_${idx + 1}`}
                                        placeholder={idx === 0 ? "Grainger Industrial" : idx === 1 ? "Motion Industries" : "Applied Industrial"}
                                        value={ref.business_name || ''}
                                        onChange={(e) => onTradeRefChange(idx, 'business_name', e.target.value)}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="email"
                                        className="form-control"
                                        name={`trade_email_${idx + 1}`}
                                        placeholder={idx === 0 ? "orders@grainger.com" : idx === 1 ? "ap@motion.com" : "credit@applied.com"}
                                        value={ref.email || ''}
                                        onChange={(e) => onTradeRefChange(idx, 'email', e.target.value)}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="tel"
                                        className="form-control"
                                        name={`trade_fax_${idx + 1}`}
                                        placeholder={`(800) 555-019${idx + 1}`}
                                        value={ref.fax || ''}
                                        onChange={(e) => onTradeRefChange(idx, 'fax', e.target.value)}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name={`trade_contact_${idx + 1}`}
                                        placeholder={idx === 0 ? "Sarah Jenkins" : idx === 1 ? "Mark Evans" : "Dave Miller"}
                                        value={ref.contact_name || ''}
                                        onChange={(e) => onTradeRefChange(idx, 'contact_name', e.target.value)}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );

    // Sub-Box 2: Bank References (2 references)
    const renderBankReferences = () => (
        <div className="ref-subbox">
            <div className="ref-subbox-header">
                <span className="ref-subbox-title">Bank References</span>
            </div>
            <div className="table-responsive">
                <table className="ref-table">
                    <thead>
                        <tr>
                            <th className="col-num">#</th>
                            <th style={{ width: '30%' }}>Bank Name</th>
                            <th style={{ width: '25%' }}>Account Number</th>
                            <th style={{ width: '20%' }}>Telephone</th>
                            <th style={{ width: '25%' }}>Contact Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(formData.bank_references || []).map((ref, idx) => (
                            <tr key={idx}>
                                <td className="row-num">{idx + 1}.</td>
                                <td>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name={`bank_name_${idx + 1}`}
                                        placeholder={idx === 0 ? "Chase Commercial Bank" : "Wells Fargo Business"}
                                        value={ref.bank_name || ''}
                                        onChange={(e) => onBankRefChange(idx, 'bank_name', e.target.value)}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name={`bank_account_${idx + 1}`}
                                        placeholder={idx === 0 ? "9823471029" : "4729103847"}
                                        value={ref.account_number || ''}
                                        onChange={(e) => onBankRefChange(idx, 'account_number', e.target.value)}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="tel"
                                        className="form-control"
                                        name={`bank_tel_${idx + 1}`}
                                        placeholder={idx === 0 ? "(314) 789-2200" : "(314) 654-8800"}
                                        value={ref.telephone || ''}
                                        onChange={(e) => onBankRefChange(idx, 'telephone', e.target.value)}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name={`bank_contact_${idx + 1}`}
                                        placeholder={idx === 0 ? "Amanda Ross" : "Robert Chen"}
                                        value={ref.contact_name || ''}
                                        onChange={(e) => onBankRefChange(idx, 'contact_name', e.target.value)}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );

    // Sub-Box 3: Amount of Credit Requested & Financial Statements
    const renderCreditAmountAndFinancials = () => (
        <React.Fragment>
            <div className="credit-amount-subbox">
                <div className="credit-amount-header">
                    <span className="credit-amount-title">Check box for amount of credit requested:</span>
                    <span className="credit-amount-note">Please attach financial statements for credit applications over $50,000.</span>
                </div>
                <div className="credit-amount-grid">
                    <label className="credit-amount-cell">
                        <input
                            type="radio"
                            name="credit_amount_requested"
                            value="5000"
                            id="credit_amt_5000"
                            checked={formData.amount_credit_requested === '5000'}
                            onChange={() => onCreditAmountChange('5000')}
                        />
                        <span>$5,000</span>
                    </label>
                    <label className="credit-amount-cell">
                        <input
                            type="radio"
                            name="credit_amount_requested"
                            value="10000"
                            id="credit_amt_10000"
                            checked={formData.amount_credit_requested === '10000'}
                            onChange={() => onCreditAmountChange('10000')}
                        />
                        <span>$10,000</span>
                    </label>
                    <label className="credit-amount-cell">
                        <input
                            type="radio"
                            name="credit_amount_requested"
                            value="25000"
                            id="credit_amt_25000"
                            checked={formData.amount_credit_requested === '25000'}
                            onChange={() => onCreditAmountChange('25000')}
                        />
                        <span>$25,000</span>
                    </label>
                    <div className="credit-amount-cell">
                        <label htmlFor="credit_amt_other" className="m-0 d-flex align-items-center gap-1">
                            <input
                                type="radio"
                                name="credit_amount_requested"
                                value="other"
                                id="credit_amt_other"
                                checked={formData.amount_credit_requested === 'other'}
                                onChange={() => onCreditAmountChange('other')}
                            />
                            <span>Other Amount:</span>
                        </label>
                        <input
                            type="text"
                            className="form-control other-amt-input"
                            id="other_amount_val"
                            name="other_amount_val"
                            placeholder="$"
                            value={formData.other_amount_val || ''}
                            onChange={onChange}
                            onFocus={() => onCreditAmountChange('other')}
                        />
                    </div>
                </div>
            </div>

            {/* Financial statement file upload (optional over $50k) */}
            <div className="row g-2 mb-2 align-items-center">
                <div className="col-md-7 col-12">
                    <span className="small text-muted">
                        <i className="fa fa-info-circle me-1"></i>Financial statements (for credit requested over $50,000):
                    </span>
                </div>
                <div className="col-md-5 col-12">
                    <input
                        type="file"
                        className="form-control"
                        id="financial_statements_file"
                        name="financial_statements_file"
                        accept=".pdf,.xlsx,.xls,.doc,.docx"
                        onChange={(e) => onFileChange('financial_statements_file', e.target.files[0])}
                    />
                    {finFile && (
                        <div className="upload-file-display active mt-1">
                            <i className="fa fa-file text-success me-1"></i>
                            <span className="fw-bold">{finFile.name}</span>
                            <button
                                type="button"
                                className="btn-remove-file ms-auto"
                                onClick={() => onRemoveFile('financial_statements_file')}
                                title="Remove file"
                            >
                                <i className="fa fa-times"></i>
                            </button>
                        </div>
                    )}
                </div>
            </div>

            {/* Security Notice */}
            <p className="credit-security-notice">
                <strong>Security :</strong> All approved credit accounts are subject to service charges on balances greater than 30 days past due at a rate of 1.5% per calendar month.
            </p>
        </React.Fragment>
    );

    // Section 4: Authorization, Legal Terms & Signatures
    const renderLegalAndSignature = () => (
        <div className="legal-terms-section">
            <p className="legal-text-p">
                I understand that the information on this page is for the sole purpose of obtaining credit from Techtop Industries, Incorporated. I certify that to the best of my knowledge, all the information provided herein is true and complete. I authorize Techtop Industries to inquire as to the credit worthiness of my firm. My firm does herein agree to guarantee all indebtedness that may become due either directly or indirectly as a result of the extension of this credit including but not limited to the debt and any attorney fees or legal expenses associated with the collection of such debt. I further agree that this guarantee is absolute, complete and continuing and no notice of any extension of credit already or hereafter contracted by or extended need be provided to me. The terms herein may be extended, renewed or changed without prior notice to me. In order to secure payment of all sums owed to Techtop Industries, Inc. your firm does herein grant security interest in any and all goods sold to your firm.
            </p>
            <p className="legal-auth-statement">
                I, the undersigned, am duly authorized to and do hereby bind my firm to the terms and conditions set forth herein.
            </p>

            {/* Signature & Details Fields */}
            <div className="signature-grid">
                <div className="row g-3 mb-2">
                    <div className="col-md-7 col-12">
                        <div className="sig-field-group">
                            <label className="sig-label" htmlFor="customer_signature">Signature:</label>
                            <input
                                type="text"
                                className="form-control signature-input"
                                id="customer_signature"
                                name="signature"
                                placeholder="Signature"
                                value={formData.signature || ''}
                                onChange={onChange}
                                required
                            />
                        </div>
                    </div>
                    <div className="col-md-5 col-12">
                        <div className="sig-field-group">
                            <label className="sig-label" htmlFor="signature_date">Date:</label>
                            <input
                                type="date"
                                className="form-control"
                                id="signature_date"
                                name="submission_date"
                                value={formData.submission_date || ''}
                                onChange={onChange}
                                required
                            />
                        </div>
                    </div>
                </div>
                <div className="row g-3">
                    <div className="col-md-6 col-12">
                        <div className="sig-field-group">
                            <label className="sig-label" htmlFor="print_name">Print Name:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="print_name"
                                name="print_name"
                                placeholder="Full Name"
                                value={formData.print_name || ''}
                                onChange={onChange}
                                required
                            />
                        </div>
                    </div>
                    <div className="col-md-6 col-12">
                        <div className="sig-field-group">
                            <label className="sig-label" htmlFor="signer_title">Title:</label>
                            <input
                                type="text"
                                className="form-control"
                                id="signer_title"
                                name="title"
                                placeholder="Title"
                                value={formData.title || ''}
                                onChange={onChange}
                                required
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="version-tag">Version 1.1</div>
        </div>
    );

    // Section 5: Routing Summary & Action Buttons
    const renderRoutingAndActions = () => (
        <React.Fragment>
            <div className="p-3 bg-light border mb-4">
                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
                    <div>
                        <span className="fw-bold text-dark" style={{ fontSize: '13.5px' }}>Applicant Company:</span>
                        <span className="text-teal fw-bold ms-1">
                            {formData.company_name?.trim() || 'New Customer Account'}
                        </span>
                    </div>
                    <div className="small text-muted">
                        Transmitting complete packet to <strong>Billing@techtopind.com</strong>
                    </div>
                </div>
            </div>

            <div className="form-actions-bar d-flex justify-content-between align-items-center">
                <button type="button" className="back-btn" onClick={() => onBack(2)} disabled={isSubmit}>
                    <i className="fa fa-arrow-left me-1"></i> Back to Step 2
                </button>
                <button type="submit" className="submit-btn" id="submitFormBtn" disabled={isSubmit}>
                    {isSubmit ? 'Submitting Application...' : 'Submit Application & Documents'}
                </button>
            </div>
        </React.Fragment>
    );

    return (
        <div id="step_3_content">
            <div className="section-head-row mb-3">
                <h3 className="section-heading-text">
                    <i className="fa fa-file-invoice-dollar text-teal me-2"></i>Step 3: Credit Terms Application
                </h3>
            </div>

            <div className="credit-terms-container">
                <div className="credit-terms-title">
                    Credit Terms: Application for credit must be completed for terms other than advance payment.
                </div>

                {renderTradeReferences()}
                {renderBankReferences()}
                {renderCreditAmountAndFinancials()}
            </div>

            {renderLegalAndSignature()}
            {renderRoutingAndActions()}
        </div>
    );
};

export default Step3;
